// src/components/DailyPhoto.jsx
import React, { useState, useEffect } from "react";
import { photos } from "../data/photos";
import styles from "./DailyPhoto.module.css";

function DailyPhoto() {
  const [dailyPhoto, setDailyPhoto] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (photos.length === 0) return;

    const today = new Date();
    const startOfYear = new Date(today.getFullYear(), 0, 0);
    const dayOfYear = Math.floor((today - startOfYear) / 1000 / 60 / 60 / 24);

    const dailyPhotoIndex = dayOfYear % photos.length;
    setDailyPhoto(photos[dailyPhotoIndex]);
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = "unset";
  };

  return (
    <div className={styles.container}>
      {dailyPhoto && (
        <>
          <div className={styles.imageContainer} onClick={handleOpenModal}>
            <img
              src={dailyPhoto.url}
              alt={dailyPhoto.caption}
              className={styles.image}
            />
          </div>
          <p className={styles.caption}>{dailyPhoto.caption}</p>
          <a
            href={dailyPhoto.url}
            download={dailyPhoto.caption || "daily-photo"}
            className={styles.downloadLink}
          >
            <button className={styles.downloadButton}>Download</button>
          </a>
        </>
      )}

      {isModalOpen && dailyPhoto && (
        <div className={styles.modalOverlay} onClick={handleCloseModal}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={dailyPhoto.url}
              alt={dailyPhoto.caption}
              className={styles.modalImage}
            />
            <button className={styles.closeButton} onClick={handleCloseModal}>
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DailyPhoto;
